<template>
	<div class="mod-contribute">
		<el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%" :header-cell-style="{ background: '#F2F3F5' }">
			<el-table-column type="index" header-align="center" align="center" width="50" label="序号"> </el-table-column>
			<el-table-column prop="title" header-align="center" align="center" label="需求标题"> </el-table-column>
			<el-table-column prop="introduction" header-align="center" align="center" label="需求简介"> </el-table-column>
			<el-table-column prop="status" header-align="center" align="center" label="状态">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.st === 0" size="small" type="danger">待处理</el-tag>
					<el-tag v-else size="small">已处理</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" header-align="center" align="center" label="投稿时间">
				<template slot-scope="scope">
					{{ scope.row.createTime | formatDate }}
				</template>
			</el-table-column>
			<el-table-column fixed="right" header-align="center" align="center" width="150" label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="seeDetail(scope.row.id)">查看</el-button>
					<!-- <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.userId)">修改</el-button> -->
					<el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="mod-page">
			<pagination v-show="totalPage > 0" :total="totalPage" :page.sync="tablePage" :limit.sync="tableSize" @pagination="getDataList" />
		</div>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { formatdate } from '@/utils/index'
export default {
	components: {
		Pagination,
	},
	data() {
		return {
			dataList: [],
			tablePage: 1,
			tableSize: 10,
			totalPage: 0,
			dataListLoading: false,
			dataListSelections: [],
		}
	},
	filters: {
		formatDate(time) {
			if (!time) return
			var date = new Date(time)
			return formatdate(date, 'yyyy-MM-dd hh:mm:ss') // 此处可根据自己的需要自定义想要的日期格式
		},
	},
	created() {
		this.getDataList()
	},
	methods: {
    seeDetail(id){
      this.$router.push({ name: "serviceUserAdd", query: { id: id } });
    },
		deleteHandle(id) {
			this.$confirm(`确定进行[ "删除"]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				this.$http.post(this.$api.userApi.contributeDel, { id: id }).then(() => {
					this.getDataList()
				})
			})
		},
		getDataList() {
			this.tabLoading = true
			let params = {
				current: this.pageIndex,
				size: this.pageSize,
				data: {},
			}
			this.$http.post(this.$api.userApi.contributeList, params).then(({ data }) => {
				this.tabLoading = false
				this.dataList = data.data.list
				this.totalPage = data.data.total
			})
		},
	},
}
</script>

<style lang="scss" scoped></style>
